export default "//yastatic.net/s3/distribution/pythia/frontend/_/7e922a609520a751e9c36bb13c158f31.png";